export { default } from './bank-offers-error';
